import React from 'react';
import { connect } from 'react-redux';
import SelectOptionDisplay from './SelectOptionComponent';
import Valg, { DisplayValue } from '../Models/Valg';
import VeilederStegComponent, { VeilederStegDefaultProps, VeilederStegBaseProps } from './VeilederStegComponent';
import { AppState } from '../Store/Types';
import { setCollapsed } from '../Store/StegVisning/Actions';
import { StegVisning } from '../Store/StegVisning/Types';

type VelgUniversitetComponentOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    options: DisplayValue[],
    ledetekst: JSX.Element | null,
    onSelectChange: any,
    showSearch?: boolean,
    value?: Valg<string>,
    avhukingBoksTekst: JSX.Element | null,
    ingenValgTekst: string | null,
}

type VelgUniversitetDisplayProps = VelgUniversitetComponentOwnProps & MapStateToProps & MapDispatchToProps;

function VelgUniversitetComponentVisning (props: VelgUniversitetDisplayProps): JSX.Element {

    function ikkeGodkjentUniversitetAvhukingHandler(e: React.SyntheticEvent<HTMLInputElement>): void {
        if(e.currentTarget.checked) {
            let ingenTilleggsstipend: Valg<string> = { id: "Nei", displayValue: (props.ingenValgTekst ?? ''), value: "Nei"}
            props.onSelectChange(ingenTilleggsstipend);
            props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:true});
        } else {
            //setter til undefined siden brukeren da må velge universitet fra listen isteden. 
            props.onSelectChange(undefined);
        }
    }

    function onSelectHandling(valg: Valg<string>) : void {
        props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:true});

        props.onSelectChange(valg);
        
        let avhukingsboks: HTMLInputElement | null = document.getElementById("checkbox-tilleggsstipend") as HTMLInputElement | null;
        if(avhukingsboks !== null)
            avhukingsboks.checked = false;
    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={props.forklaring}
            canCollapse={props.value != null}
            displayElement={<div className="c-veileder__valgt-item">
                <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
            </div>}
            inputArea={<div className="c-veileder__inputomrade">
                <SelectOptionDisplay
                    htmlId={props.sporsmalId+'-uni-select'}
                    ledetekst={props.ledetekst}
                    options={props.options}
                    onSelectChange={(nyttValg: Valg<string>): void => {
                        onSelectHandling(nyttValg);
                    }}
                    showSearch={props.showSearch}
                    value={props.value}
                />
                <div className="c-veileder__checkbox">
                    <input onChange={ikkeGodkjentUniversitetAvhukingHandler} type="checkbox" id="checkbox-tilleggsstipend" />
                    <label htmlFor="checkbox-tilleggsstipend">{props.avhukingBoksTekst}</label>
                </div>
            </div>}
            sporsmalId={props.sporsmalId}
        />
    )
}

interface MapStateToProps {
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: AppState, ownProps: VelgUniversitetComponentOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(VelgUniversitetComponentVisning);